import { render } from "./ProposalCreateModal.vue?vue&type=template&id=6cb78d67"
import script from "./ProposalCreateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposalCreateModal.vue?vue&type=script&setup=true&lang=js"

import "./ProposalCreateModal.vue?vue&type=style&index=0&id=6cb78d67&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/governance/ProposalCreateModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6cb78d67"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6cb78d67', __exports__)) {
    api.reload('6cb78d67', __exports__)
  }
  
  module.hot.accept("./ProposalCreateModal.vue?vue&type=template&id=6cb78d67", () => {
    api.rerender('6cb78d67', render)
  })

}


export default __exports__